import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
export default {
  name: 'service-maintenance',
  components: {pageheader},
  data () {
    return {
      input : {},
      isLoadCards: false,
      serviceMaintenanceList: [],
      linkServiceTemplateDialog: false,
      selectedTemplate: {},
      serviceTitle: "",
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
      
        { text: 'TU Serial#', value: 'tuSerialNumber' },
        { text: 'Category', value: 'category' },
        { text: 'Brand', value: 'brand' },
        { text: 'Model', value: 'model' },
        { text: 'Year', value: 'year' },
      ],
      equipmentsList: [
      ],
      selectedAssets: [],
      isAsset: false,
      selectedCustomer: "",
      customers: [],
      categories: [],
      selectedCategory: "",
      isCategory: false,
      search: "",
      isSubmit: false,
      parentCompaniesList: [],
      isLoaderCust: false,
      isGetServiceTemplate: false,
      isSelectServiceTemplate: false
    }
  },
  computed: {
    ...mapGetters(["roles","serviceModuleStepModel","serviceTemlateDetails"]),
  },
  filters: {
    numberFormat: function(value){
      if(value != 'Quarterly' || value != 'Monthly' || value != 'yearly'){
        return Number(value).toLocaleString();
      }
    }
  },
  mounted () {
    this.input = utils.getInputContent("mapNewServiceTemplate", this.roles);
    this.getCompanyList();
    this.getCategories();
    this.getServiceTemplateList();
    if(this.serviceModuleStepModel == 2){
      this.getServiceTemplateDetailsById();
      this.getServiceEquipments();
    }
  },
  beforeDestroy() {
    this.$store.dispatch("setServiceModuleStepModel", 1);
  },
  methods: {
    async getCompanyList() {
      this.isLoaderCust = true;
        let finalLists = [];
        try{
          const response = await telematicsService.getBasicCustomers();
          if (response.isSuccess) {
            this.isLoaderCust = false;
            finalLists = response.data.filter((e) => e.name !== "");
                this.parentCompaniesList = finalLists;
          } else {
            this.isLoaderCust = false;
            this.parentCompaniesList = [];
          }
        }catch(err){
          this.isLoaderCust = false;
          console.log(err);
        }
    },
    async getCategories(){
      this.isCategory = true;
      try{
        let response = await telematicsService.getserviceModuleCategories();
        if(response.isSuccess){
          this.isCategory = false;
          this.categories = response.data;
        }else{
          this.isCategory = false;
          this.categories = [];
        }
      }catch(err){
        this.isCategory = false;
        console.log(err);
      }
    },
    async getServiceTemplateList(){
      this.$store.dispatch("setServiceModuleStepModel", 1);
      this.isSelectServiceTemplate = true;
      this.isLoadCards = true;
      try{
        let response = await telematicsService.getServiceTemplateList();
        if(response.isSuccess){
          this.isLoadCards = false;
          this.serviceMaintenanceList = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
            active: false
          }));
        }else{
          this.isLoadCards = false;
          this.serviceMaintenanceList = [];
        }
      }catch(err){
        this.isLoadCards = false;
        console.log(err);
      }
    },
    selectServiceTemplate(template){
      this.isSelectServiceTemplate = false;
      this.serviceMaintenanceList.map((item) => {
        if (item.id == template.id) {
          item.active = true;
          
        } else {
          item.active = false;
        }
        return item;
      });
      this.$store.dispatch("setServiceTemplateDetails",template);
    },
    goToAssets(){
      this.getServiceTemplateDetailsById();
      this.getCompanyList();
      this.getCategories();
      this.$store.dispatch("setServiceModuleStepModel", 2);
      this.selectedAssets = [];
      this.getServiceEquipments();
    },
    async getServiceTemplateDetailsById(){
      this.isGetServiceTemplate = true;
      try{
        let response = await telematicsService.getServiceTemplateById(this.serviceTemlateDetails.id);
        if(response.isSuccess){
          this.isGetServiceTemplate = false;
          this.selectedTemplate = response.data;
        }else{
          this.selectedTemplate = {};
          this.isGetServiceTemplate = false;
        }
      }catch(err){
        this.isGetServiceTemplate = false;
        console.log(err);
      }
    },
    async getServiceEquipments(){
      this.isAsset = true;
      this.equipmentsList = [];
      try{
        let response = await telematicsService.getServiceEquipments(this.selectedCategory,this.selectedCustomer,this.search);
        if(response.isSuccess){
          this.isAsset = false;
          this.equipmentsList = response.data.map((d, index) => ({
            ...d,
            sno: index + 1
          }));
        }else{
          this.isAsset = false;
          this.equipmentsList = [];
        }
      }catch(err){
        this.isAsset = false;
        console.log(err);
      }
    },
    clearFilters(){
      this.selectedAssetType = "";
      this.selectedCategory = "";
      this.selectedCustomer = "";
      this.search = "";
      this.selectedAssets = [];
      this.getServiceEquipments();
    },
    async linkServiceTemplateWithAsset(){
      this.isSubmit = true;
      let selectedAssets = this.selectedAssets.map((x) => String(x.equipmentID));
      let payload = {
        templateId: this.serviceTemlateDetails.id,
        equipmentIds : selectedAssets
      };
      try{
        let response = await telematicsService.linkServiceTemplateWithAsset(payload);
        if(response.isSuccess){
          this.isSubmit = false;
          this.getServiceTemplateList();
          this.$toast.success('Service template assigned successfully for the selected assets');
          this.$store.dispatch("setServiceModuleStepModel", 1);
        }else{
          this.isSubmit = false;
          this.$toast.error(response.systemMessage);
        }
      }catch(err){
        console.log(err);
        this.$toast.error('Unable to link service template with asset');
      }
    },
    clearData(){
      this.selectedAssets = [];
    },
    backToTemplatesList(){
      this.$store.dispatch("setServiceModuleStepModel", 1);
      this.getServiceTemplateList();
    },
  }
}


